import { default as BSTab } from 'bootstrap/js/src/tab'

class Tab extends BSTab {}

export default Tab
